import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { Stopa } from './stopa';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-stopa',
  templateUrl: './stopa.component.html'
})
export class StopaComponent extends BaseModalContainer<Stopa> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Stopa>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
